import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Modal, ModalBody } from '@lanl-web/lanl-components';
import { useMobileBool } from '../../utils';

import './ButtonModal.scss';

export const ButtonModal = (props) => {
  const { video } = props;

  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <p className='lanl-btn-modal'>
      <Button
        onClick={(e) => {
          e.preventDefault();
          setModalIsOpen(true);
        }}
      >
        Watch Video
      </Button>
      <Modal
        isOpen={modalIsOpen}
        toggle={() => setModalIsOpen(false)}
        size={useMobileBool() ? 'fluid' : 'xl'}
        centered
      >
        <ModalBody>
          <iframe
            title={video.title}
            src={video.src}
            className='video-iframe'
          />
        </ModalBody>
      </Modal>
    </p>
  );
};

ButtonModal.defaultProps = {};

ButtonModal.propTypes = {
  video: PropTypes.shape({
    src: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
};

export default ButtonModal;
